export default __webpack_public_path__ + "static/media/navigate_beforechevron_left.a71695bf.svg";